module.exports = __webpack_public_path__ + "3777ae677f24cba9627d1a7648b054f6.svg";